module.exports = __webpack_public_path__ + "img/rzye-logo.153355ed.png";